import { render, staticRenderFns } from "./desModel.vue?vue&type=template&id=6175aba4&scoped=true&"
import script from "./desModel.vue?vue&type=script&lang=js&"
export * from "./desModel.vue?vue&type=script&lang=js&"
import style0 from "./desModel.vue?vue&type=style&index=0&id=6175aba4&scoped=true&lang=css&"
import style1 from "./desModel.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6175aba4",
  null
  
)

export default component.exports